import { render, staticRenderFns } from "./TableCdpsSaves.vue?vue&type=template&id=5e085ea4&"
import script from "./TableCdpsSaves.vue?vue&type=script&lang=ts&"
export * from "./TableCdpsSaves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports